// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"961a3039","176":"4690bcfb","205":"9d84dda1","378":"bc5d9ad9","608":"4690bcfb","692":"4690bcfb"}[chunkId] + ".chunk.css";
};